import styled from "styled-components"

export const WheelHouseWrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: #d22cc31a;
	padding: 12px;
	border-radius: 12px;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 12px;
	flex-direction: column;
	form {
		width: 100%;
		div {
			width: 100%;
			p {
				margin: 0;
				padding: 0;
				color: #435363;
				font-weight: 400;
				font-size: 12px;
				line-height: 100%;
				letter-spacing: 0%;
			}
		}
		.containerHeaderWellHouse {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 12px;
			span {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
		}
	}
`
